import { render } from "./SupportPage.vue?vue&type=template&id=06bc9fbc"
import script from "./SupportPage.vue?vue&type=script&lang=js"
export * from "./SupportPage.vue?vue&type=script&lang=js"
script.render = render

export default script